import {useState} from 'react';

import {VisibilityIcon, VisibilityOffIcon} from 'icons';
import {SizeTokenValue} from 'common';
import {Input, InputButton} from 'Input';

import type {InputHTMLAttributes} from 'react';

import type {PasswordInputProps} from './types';

export const PasswordInput: React.FC<PasswordInputProps> = ({qa = 'password', ...props}) => {
  const [isOpen, setIsOpen] = useState<boolean>(false);

  const Icon = isOpen ? VisibilityIcon : VisibilityOffIcon;

  const type: InputHTMLAttributes<HTMLInputElement>['type'] = isOpen ? 'text' : 'password';

  const endAdornment = (
    <InputButton
      type="button"
      data-qa={`${qa}-toggle`}
      isDisabled={props.disabled}
      isSmall={props.size === SizeTokenValue.Small}
      onClick={() => setIsOpen(!isOpen)}
    >
      <Icon size={props.size} />
    </InputButton>
  );

  return <Input endAdornment={endAdornment} type={type} qa={qa} {...props} />;
};
